type EntityWithID = {
  ID: string;
};

export const pickIDs = (objs: EntityWithID[]): string[] => {
  return objs.map(({ ID }) => ID);
};
